<h2>about lilly.</h2>
<p class="about">Die ersten 6 Wochen meines Lebens habe ich auf den Straßen von Kroatien verbracht, bis mein Papa
    mich in eine Sporttasche gesteckt hat und nach Deutschland brachte. Hier hat mich dann das Luxusleben auserwählt.
    Ich besitze ein Haus mit großem Hof. In meinem Haus habe ich die Auswahl zwischen 5 Betten und von meinen zwei 
    Angestellten bekomme ich Streicheleinheiten wann ich möchte... aber die Straße bleibt immer Teil von mir. 
</p>